import React, { useEffect, useState } from 'react'
import { makeStyles, Typography } from '@material-ui/core';
import TableAction from 'actions/table_actions';
import tableIcons, { options } from 'components/universal/table_attributes';
import MaterialTable from 'material-table';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { getOrganisationId } from 'lib/utils/common_utils';


const useStyles = makeStyles((theme) => ({
    subTitle: {
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "10px",
        marginTop: "20px",
    },
}));


export default function ExchangeDetails(props) {
    const { coreId, isRefreshTable } = props



    const classes = useStyles()
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(null)
    const tableOptions = {
        ...options,

        paging: false,
        search: false,
        toolbar: false,

    };
    

    const getFinanceDetails = async () => {
        setLoading(true)
        const param = {
            sales_order_core_id: coreId
        }
        await PartSalesServices.getFinanceCoreDetails(param).then((res) => {
            setData(res?.data)
        }).catch(() => {

        }).finally(() => {
            setLoading(false)
        })

    }



    useEffect(() => {
        if (coreId)
            getFinanceDetails()
    }, [coreId, isRefreshTable])








    const columns = [
        {
            title: "Item",
            field: "item",
            headerStyle: {
                paddingLeft: "19px",
                textAlign: "left",
            },
            cellStyle: {
                paddingLeft: "19px",
                textAlign: "left",
                width: "30%",
            },
        },


        {
            title: "Total",
            field: "value",
            headerStyle: {
                paddingRight: '18px',
                textAlign: "right",
            },
            cellStyle: {
                paddingRight: '18px',
                textAlign: "right",
            },
            render: (rowData) => <span >
                {rowData?.value || "0.00"}
            </span>
        },
    ];


    return (
        <div>
            <Typography variant="h6" className={classes.subTitle}>
                Core Exchange Details
            </Typography>

            <MaterialTable
                style={{ paddingBottom: "42px" }}
                icons={tableIcons}
                columns={columns}
                data={data || []}
                isLoading={loading}
                options={tableOptions}

            />
            <Typography style={{ fontSize: "14px", fontStyle: "italic", marginTop: "10px" }}>
                * Total is adjusted to 0.00 in the case of minus value
            </Typography>







        </div>
    )
}
